/**
 * Strip undefined values before Firestore write.
 * Converts undefined → null via JSON round-trip.
 */
export function stripUndefined(obj) {
  return JSON.parse(JSON.stringify(obj, (_, v) => (v === undefined ? null : v)));
}
